export default "__VITE_ASSET__Iw61sSki__"